export default __webpack_public_path__ + "static/media/check-circle.05bc4b2d.svg";